import React, { Component, Fragment } from 'react';

import { Loader } from 'components/loader';
import {
  ConfirmNavigation,
  renderConfirmNavigationModal
} from 'components/modal';
import { Tabs } from 'components/tabs';
import { translate } from 'components/translate';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { UserSegmentationService } from 'modules/userManager';
import PropTypes from 'prop-types';

@translate()
@inject((stores) => ({
  active: stores.UserSegmentationStore.active,
  segmentation: stores.UserSegmentationStore.segmentation,
  segmentations: stores.UserSegmentationStore.segmentations
}))
@observer
class UsersSegmentations extends Component {
  // #region set up
  static propTypes = {
    active: PropTypes.number,
    children: PropTypes.node,
    segmentation: MobxPropTypes.objectOrObservableObject,
    segmentations: MobxPropTypes.arrayOrObservableArray,
    t: PropTypes.func
  };

  state = {
    loading: true
  };

  constructor(props) {
    super(props);

    this.onCancel = this.onCancel.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onConfirmSecondary = this.onConfirmSecondary.bind(this);
    this.onTabChange = this.onTabChange.bind(this);

    this.modalConfigs = {
      bodyLabel: 'users_manager.segmentation.confirm_navigation',
      onCancel: this.onCancel,
      onConfirm: { action: this.onConfirm, label: 'general.save_and_go' },
      onConfirmSecondary: {
        action: this.onConfirmSecondary,
        label: 'general.discard_and_go'
      },
      title: 'general.save_changes_question'
    };
  }

  async componentDidMount() {
    await this.getSegmentations();
    UserSegmentationService.setSegmentationByIndex(0);
  }
  // #endregion

  // #region actions
  async getSegmentations() {
    this.setState({ loading: true });

    await UserSegmentationService.getSegmentations();

    this.setState({ loading: false });
  }

  async changeSegmentation(active) {
    await UserSegmentationService.setSegmentationByIndex(active);
    UserSegmentationService.performSearch({ showLoading: false });
  }

  async saveSegmentation() {
    return UserSegmentationService.save();
  }
  // #endregion

  // #region handlers
  async onTabChange(active) {
    if (UserSegmentationService.isDirty) {
      this.setState({ preventLeave: true, active });
      return;
    }

    await this.changeSegmentation(active);
  }

  async onConfirm() {
    try {
      await this.saveSegmentation();
      await this.changeSegmentation(this.state.active);
    } finally {
      this.onCancel();
    }
  }

  async onConfirmSecondary() {
    await this.changeSegmentation(this.state.active);
    this.onCancel();
  }

  onCancel() {
    this.setState({ preventLeave: false });
  }

  mapTabName = (segm) => ({ name: segm.name });
  // #endregion

  // #region render
  render() {
    const { loading } = this.state;
    const { active, children } = this.props;

    if (loading) {
      return <Loader key="loader" />;
    }

    return (
      <Fragment>
        <Tabs actived={active} onTabChange={this.onTabChange} tabs={this.tabs}>
          {children}
        </Tabs>

        {this.renderPreventLeave()}
      </Fragment>
    );
  }

  get tabs() {
    const { segmentations = [], t } = this.props;
    const segmentationsNames =
      segmentations.length > 1
        ? segmentations.slice(1).map(this.mapTabName)
        : [];

    return [
      { name: t('users_manager.users_list.header.tab_all_users') },
      ...segmentationsNames
    ];
  }

  renderPreventLeave() {
    const modalConfigs = this.modalConfigs;

    return (
      <Fragment>
        <ConfirmNavigation
          {...modalConfigs}
          onConfirm={{
            action: this.saveSegmentation,
            label: modalConfigs.onConfirm.label
          }}
          onConfirmSecondary={{
            action: () => true,
            label: modalConfigs.onConfirmSecondary.label
          }}
          shouldConfirmNavigation={UserSegmentationService.isDirty}
        />

        {this.state.preventLeave && renderConfirmNavigationModal(modalConfigs)}
      </Fragment>
    );
  }
  // #endregion
}

export default UsersSegmentations;
